/**
 * smooth-scroll.js
 * ページ内アンカーリンクのスムーススクロール
 *
 * 【仕様】
 * - href="#xxx" 形式のリンクをクリックしたとき、対象要素までスムーズにスクロールする
 * - href="#" のみのリンク（ページトップに戻るなど）は対象外
 * - breakpoint 以上の幅を desktop、未満を mobile として offset を切り替える
 * - data-scroll-offset 属性がある場合はその値を優先（単位: px）
 *
 * 【デフォルト値】
 * - breakpoint : 1024  （1024px 以上が desktop 扱い）
 * - offset.desktop : 100px
 * - offset.mobile  : 80px
 *
 * 【使い方】
 * // デフォルト設定のまま使う
 * initSmoothScroll();
 *
 * // 一部だけ上書き（省略した値はデフォルトを使用）
 * initSmoothScroll({ breakpoint: 1200 });
 * initSmoothScroll({ offset: { desktop: 120 } });
 *
 * // すべて指定
 * initSmoothScroll({ breakpoint: 1200, offset: { desktop: 120, mobile: 60 } });
 *
 * // リンクごとに個別指定（data属性で上書き）
 * <a href="#section" data-scroll-offset="0">リンク</a>
 */

const DEFAULTS = {
  breakpoint: 1024,
  offset: {
    desktop: 100,
    mobile: 80,
  },
};

export function initSmoothScroll(options = {}) {
  const breakpoint = options.breakpoint ?? DEFAULTS.breakpoint;
  const offset = {
    desktop: options.offset?.desktop ?? DEFAULTS.offset.desktop,
    mobile:  options.offset?.mobile  ?? DEFAULTS.offset.mobile,
  };

  const getOffset = (anchor) => {
    const custom = parseInt(anchor.dataset.scrollOffset, 10);
    if (!isNaN(custom)) return custom;
    return window.matchMedia(`(min-width: ${breakpoint}px)`).matches
      ? offset.desktop
      : offset.mobile;
  };

  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (href === '#') return;

    const target = document.querySelector(href);
    if (!target) return;

    e.preventDefault();

    const top = target.getBoundingClientRect().top + window.scrollY - getOffset(anchor);
    window.scrollTo({ top, behavior: 'smooth' });
  });
}
